(function () {
	function swiperInit(isUpdate) {
		subSliderInit(isUpdate);
		sliderInit(isUpdate);
	}

	document.addEventListener('shopify:section:load', function (e) {
		swiperInit(true);
	});

    window.addEventListener('resize', function () {
		$('.js-media-list').each(function () {
			this.swiper.destroy();
		});
		$('.js-media-sublist').each(function () {
			this.swiper.destroy();
		});

		swiperInit(true);
	});

	swiperInit(false);
})();
